import styled from "styled-components";

export const Circle = styled.div.attrs({
  className: `
    flex
    items-center
    justify-center
    border-4
    border-amber-600
    rounded-full
    h-24
    w-24
    text-5xl
    zombie-font
  `,
})``;
